import { Route, Routes } from "react-router-dom";
import { getKey } from "../helpers/sessionKey";
import DashboardLayout from "../layouts/DashboardLayout";
import AccountInfo from "../pages/Account/AccountInfo";
import CreateAccount from "../pages/Account/CreateAccount";
import EditAccount from "../pages/Account/EditAccount";
import ChartsOfAccounts from "../pages/ChartsOfAccounts";
import Dashboard from "../pages/Dashboard";
import PageNotFound from "../pages/ErrorPage/PageNotFound";
import GeneralLegder from "../pages/GeneralLegder/LedgerAccount";
import CreateJournalEntry from "../pages/JournalEntry/Create";
import EditJournalEntry from "../pages/JournalEntry/Edit";
import JournalEntry from "../pages/JournalEntry/List";
import ProfitAndLoss from "../pages/ProfitAndLoss";
import BankPayment from "../pages/Transaction/Bank/BankPayment";
import BankReceipt from "../pages/Transaction/Bank/BankReceipt";
import CashPayment from "../pages/Transaction/Cash/CashPayment";
import CashReceipt from "../pages/Transaction/Cash/CashReceipt";
import TrialBalance from "../pages/TrialBalance/TrialBalanceDetail";
import PrivateRoute from "./PrivateRoute";
//@ts-ignore
import { WelcomeRouterService } from "@careinfo/welcome-page-service";
import BalanceSheet from "../pages/BalanceSheet";
import CreditNote from "../pages/CreditNote";
import CreateCreditNote from "../pages/CreditNote/CreateCreditNote";
import EditCreditNote from "../pages/CreditNote/EditCreditNote";
import DebitNote from "../pages/DebitNote";
import CreateDebitNote from "../pages/DebitNote/CreateDebitNote";
import EditDebitNote from "../pages/DebitNote/EditDebitNote";
import InventoryInfo from "../pages/InventoryInfo";
import AddProduct from "../pages/InventoryInfo/AddProduct";
import EditProduct from "../pages/InventoryInfo/EditProduct";
import StockMovement from "../pages/InventoryReport/StockMovementGroup";
import StockMovementNormal from "../pages/InventoryReport/StockMovementNormal";
import StockTrial from "../pages/InventoryReport/StockTrialGroup";
import StockTrialNormal from "../pages/InventoryReport/StockTrialNormal";
import StockValuation from "../pages/InventoryReport/StockValuationGroup";
import StockValuationNormal from "../pages/InventoryReport/StockValuationNormal";
import StockLedgerNormal from "../pages/InventoryReport/StoclLedgerNormal";
import Profile from "../pages/Profile";
import AddPurchase from "../pages/Purchase/AddPurchase";
import EditDraftPurchase from "../pages/Purchase/EditDraftPurchase";
import PurchaseList from "../pages/Purchase/PurchaseList";
import Sales from "../pages/Sales";
import AddSales from "../pages/Sales/AddSales";
import EditDraftSales from "../pages/Sales/EditDraftSales";
import SalesReturn from "../pages/SalesReturn";
import Configuration from "../pages/Setup/Configuration";
import CreateBankPayment from "../pages/Transaction/Bank/CreateBankPayment";
import CreateBankReceipt from "../pages/Transaction/Bank/CreateBankReceipt";
import EditBankPayment from "../pages/Transaction/Bank/EditBankPayment";
import EditBankReceipt from "../pages/Transaction/Bank/EditBankReceipt";
import CreateCashPayment from "../pages/Transaction/Cash/CreateCashPayment";
import CreateCashReceipt from "../pages/Transaction/Cash/CreateCashReceipt";
import EditCashPayment from "../pages/Transaction/Cash/EditCashPayment";
import EditCashReceipt from "../pages/Transaction/Cash/EditCashReceipt";
import Setting from "../pages/Setup/Setting";
import AddSalesReturn from "../pages/SalesReturn/AddSalesReturn";
import EditSalesReturn from "../pages/SalesReturn/EditSalesReturn";
import PurchaseReturnList from "../pages/PurchaseReturn";
import AddPurchaseReturn from "../pages/PurchaseReturn/AddPurchaseReturn";
import EditPurchaseReturn from "../pages/PurchaseReturn/EditPurchaseReturn";
import StockLedgerDetail from "../pages/InventoryReport/StockLedgerDetail";
import StockValuationDetail from "../pages/InventoryReport/StockValuationDetail";
import ProductGroupList from "../pages/InventoryInfo/ProductGroupList";
import PurchaseRegister from "../pages/CBMSReports/PurchaseRegister";
import SalesRegister from "../pages/CBMSReports/SalesRegister";
import SalesReturnRegister from "../pages/CBMSReports/SalesReturnRegister";
import PurchaseReturnRegister from "../pages/CBMSReports/PurchaseReturnRegister";
import TrialBalanceGroup from "../pages/TrialBalance/TrialBalanceGroup";
import LedgerParty from "../pages/GeneralLegder/LedgerParty";
import ServiceInfo from "../pages/ServiceInfo";
import AddService from "../pages/ServiceInfo/CreateServiceInfo";
import EditServiceInfo from "../pages/ServiceInfo/EditServiceInfo";
import ServiceReport from "../pages/ServiceReport";
import {
  AccessControl,
  PermissionRequired,
} from "@careinfo/permission-required";
import SettingIrd from "../pages/Setup/SettingIrd";
import DailyNote from "../pages/DailyNote/DailyNote";
import CreateDailyNote from "../pages/DailyNote/CreateDailyNote";
import EditDailyNote from "../pages/DailyNote/EditDailyNote";
import DailyNoteRouter from "./DailyNoteRouter";
import CustomerList from "../pages/Customer/CustomerList";
import SupplierListPage from "../pages/Supplier/SupplierList";
import CreateCustomer from "../pages/Customer/CreateCustomer";
import CreateSupplier from "../pages/Supplier/CreateSupplier";
import EditCustomer from "../pages/Customer/EditCustomer";
import EditSupplierUser from "../pages/Supplier/EditSupplierUser";
import PartySummary from "../pages/GeneralLegder/PartySummary";

const Router = () => {
  const shouldShowWelcome = getKey("shouldShowWelcome");
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route
          path={"/"}
          element={
            shouldShowWelcome === "true" || shouldShowWelcome === null ? (
              <WelcomeRouterService />
            ) : (
              <AccessControl allowedPermissions={["can_view_dashboard"]}>
                <Dashboard />
              </AccessControl>
            )
          }
        />
        <Route
          path={"/accounting"}
          element={
            <AccessControl
              allowedPermissions={["can_view_dashboard"]}
              renderNoAccess={<PermissionRequired />}
            >
              <Dashboard />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/journal-voucher"}
          element={
            <AccessControl
              allowedPermissions={["can_view_journal"]}
              renderNoAccess={<PermissionRequired />}
            >
              <JournalEntry />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/journal-voucher/create"}
          element={
            <AccessControl
              allowedPermissions={["can_add_journal"]}
              renderNoAccess={<PermissionRequired />}
            >
              <CreateJournalEntry />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/journal-voucher/edit/:id"}
          element={
            <AccessControl
              allowedPermissions={["can_edit_journal"]}
              renderNoAccess={<PermissionRequired />}
            >
              <EditJournalEntry />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/general-ledger-account"}
          element={
            <AccessControl
              allowedPermissions={["can_view_account_general_ledger"]}
              renderNoAccess={<PermissionRequired />}
            >
              <GeneralLegder />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/general-ledger-party"}
          element={
            <AccessControl
              allowedPermissions={["can_view_party_general_ledger"]}
              renderNoAccess={<PermissionRequired />}
            >
              <LedgerParty />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/general-ledger-party-summary"}
          element={
            <AccessControl
              allowedPermissions={["can_view_party_general_ledger"]}
              renderNoAccess={<PermissionRequired />}
            >
              <PartySummary />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/daily-note"}
          element={
            <AccessControl
              allowedPermissions={["can_view_account_general_ledger"]}
              renderNoAccess={<PermissionRequired />}
            >
              <DailyNoteRouter />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/daily-note/create"}
          element={
            <AccessControl
              allowedPermissions={["can_view_account_general_ledger"]}
              renderNoAccess={<PermissionRequired />}
            >
              <DailyNoteRouter />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/daily-note/edit/:id"}
          element={
            <AccessControl
              allowedPermissions={["can_view_account_general_ledger"]}
              renderNoAccess={<PermissionRequired />}
            >
              <DailyNoteRouter />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/balance-sheet"}
          element={
            <AccessControl
              allowedPermissions={["can_view_balance_sheet"]}
              renderNoAccess={<PermissionRequired />}
            >
              <BalanceSheet />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/profit-and-loss"}
          element={
            <AccessControl
              allowedPermissions={["can_view_balance_sheet"]}
              renderNoAccess={<PermissionRequired />}
            >
              <ProfitAndLoss />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/trial-balance-detail"}
          element={
            <AccessControl
              allowedPermissions={["can_view_trial_balance"]}
              renderNoAccess={<PermissionRequired />}
            >
              <TrialBalance />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/trial-balance-grouped"}
          element={
            <AccessControl
              allowedPermissions={["can_view_trial_balance"]}
              renderNoAccess={<PermissionRequired />}
            >
              <TrialBalanceGroup />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/charts-of-accounts"}
          element={
            <AccessControl
              allowedPermissions={["can_view_chart_of_accounts"]}
              renderNoAccess={<PermissionRequired />}
            >
              <ChartsOfAccounts />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/profile"}
          element={
            <AccessControl
              allowedPermissions={["can_view_profile"]}
              renderNoAccess={<PermissionRequired />}
            >
              <Profile />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/settings"}
          element={
            <AccessControl
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            >
              <Setting />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/settings-ird"}
          element={
            <AccessControl
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            >
              <SettingIrd />
            </AccessControl>
          }
        />
        <Route path="/*" element={<PageNotFound />} />
        <Route
          path={"/accounting/account"}
          element={
            <AccessControl
              allowedPermissions={["can_view_account_info"]}
              renderNoAccess={<PermissionRequired />}
            >
              <AccountInfo />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/account/create"}
          element={
            <AccessControl
              allowedPermissions={["can_add_account"]}
              renderNoAccess={<PermissionRequired />}
            >
              <CreateAccount />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/account/edit/:id"}
          element={
            <AccessControl
              allowedPermissions={["can_edit_account"]}
              renderNoAccess={<PermissionRequired />}
            >
              <EditAccount />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/bank-payment"}
          element={
            <AccessControl
              allowedPermissions={["can_view_bank_payment"]}
              renderNoAccess={<PermissionRequired />}
            >
              <BankPayment />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/bank-payment/create"}
          element={
            <AccessControl
              allowedPermissions={["can_add_bank_payment"]}
              renderNoAccess={<PermissionRequired />}
            >
              <CreateBankPayment />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/bank-payment/edit/:id"}
          element={
            <AccessControl
              allowedPermissions={["can_edit_bank_payment"]}
              renderNoAccess={<PermissionRequired />}
            >
              <EditBankPayment />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/cash-payment"}
          element={
            <AccessControl
              allowedPermissions={["can_view_cash_payment"]}
              renderNoAccess={<PermissionRequired />}
            >
              <CashPayment />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/cash-payment/create"}
          element={
            <AccessControl
              allowedPermissions={["can_add_cash_payment"]}
              renderNoAccess={<PermissionRequired />}
            >
              <CreateCashPayment />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/cash-payment/edit/:id"}
          element={
            <AccessControl
              allowedPermissions={["can_edit_cash_payment"]}
              renderNoAccess={<PermissionRequired />}
            >
              <EditCashPayment />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/cash-receipt"}
          element={
            <AccessControl
              allowedPermissions={["can_view_cash_receipt"]}
              renderNoAccess={<PermissionRequired />}
            >
              <CashReceipt />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/cash-receipt/create"}
          element={
            <AccessControl
              allowedPermissions={["can_add_cash_receipt"]}
              renderNoAccess={<PermissionRequired />}
            >
              <CreateCashReceipt />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/cash-receipt/edit/:id"}
          element={
            <AccessControl
              allowedPermissions={["can_edit_cash_receipt"]}
              renderNoAccess={<PermissionRequired />}
            >
              <EditCashReceipt />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/bank-receipt"}
          element={
            <AccessControl
              allowedPermissions={["can_view_bank_receipt"]}
              renderNoAccess={<PermissionRequired />}
            >
              <BankReceipt />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/bank-receipt/create"}
          element={
            <AccessControl
              allowedPermissions={["can_add_bank_receipt"]}
              renderNoAccess={<PermissionRequired />}
            >
              <CreateBankReceipt />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/bank-receipt/edit/:id"}
          element={
            <AccessControl
              allowedPermissions={["can_edit_bank_receipt"]}
              renderNoAccess={<PermissionRequired />}
            >
              <EditBankReceipt />
            </AccessControl>
          }
        />
        <Route path={"/accounting/customer"} element={<CustomerList />} />
        <Route path={"/accounting/supplier"} element={<SupplierListPage />} />

        <Route
          path={"/accounting/sales"}
          element={
            <AccessControl
              allowedPermissions={["can_view_sales"]}
              renderNoAccess={<PermissionRequired />}
            >
              <Sales />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/sales/create"}
          element={
            <AccessControl
              allowedPermissions={["can_add_sales"]}
              renderNoAccess={<PermissionRequired />}
            >
              <AddSales />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/sales/edit/:id"}
          element={
            <AccessControl
              allowedPermissions={["can_edit_sales"]}
              renderNoAccess={<PermissionRequired />}
            >
              <EditDraftSales />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/sales-return"}
          element={
            <AccessControl
              allowedPermissions={["can_view_sales_return"]}
              renderNoAccess={<PermissionRequired />}
            >
              <SalesReturn />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/sales-return/create"}
          element={
            <AccessControl
              allowedPermissions={["can_add_sales_return"]}
              renderNoAccess={<PermissionRequired />}
            >
              <AddSalesReturn />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/sales-return/edit/:id"}
          element={
            <AccessControl
              allowedPermissions={["can_edit_sales_return"]}
              renderNoAccess={<PermissionRequired />}
            >
              <EditSalesReturn />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/credit-note"}
          element={
            <AccessControl
              allowedPermissions={["can_view_credit_note"]}
              renderNoAccess={<PermissionRequired />}
            >
              <CreditNote />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/credit-note/create"}
          element={
            <AccessControl
              allowedPermissions={["can_add_credit_note"]}
              renderNoAccess={<PermissionRequired />}
            >
              <CreateCreditNote />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/credit-note/edit/:id"}
          element={
            <AccessControl
              allowedPermissions={["can_edit_credit_note"]}
              renderNoAccess={<PermissionRequired />}
            >
              <EditCreditNote />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/debit-note"}
          element={
            <AccessControl
              allowedPermissions={["can_view_debit_note"]}
              renderNoAccess={<PermissionRequired />}
            >
              <DebitNote />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/debit-note/create"}
          element={
            <AccessControl
              allowedPermissions={["can_add_debit_note"]}
              renderNoAccess={<PermissionRequired />}
            >
              <CreateDebitNote />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/debit-note/edit/:id"}
          element={
            <AccessControl
              allowedPermissions={["can_edit_debit_note"]}
              renderNoAccess={<PermissionRequired />}
            >
              <EditDebitNote />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/purchase-return"}
          element={
            <AccessControl
              allowedPermissions={["can_view_purchase_return"]}
              renderNoAccess={<PermissionRequired />}
            >
              <PurchaseReturnList />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/purchase-return/create"}
          element={
            <AccessControl
              allowedPermissions={["can_add_purchase_return"]}
              renderNoAccess={<PermissionRequired />}
            >
              <AddPurchaseReturn />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/purchase-return/edit/:id"}
          element={
            <AccessControl
              allowedPermissions={["can_edit_purchase_return"]}
              renderNoAccess={<PermissionRequired />}
            >
              <EditPurchaseReturn />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/purchase"}
          element={
            <AccessControl
              allowedPermissions={["can_view_purchase"]}
              renderNoAccess={<PermissionRequired />}
            >
              <PurchaseList />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/purchase/create"}
          element={
            <AccessControl
              allowedPermissions={["can_add_purchase"]}
              renderNoAccess={<PermissionRequired />}
            >
              <AddPurchase />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/purchase/edit/:id"}
          element={
            <AccessControl
              allowedPermissions={["can_edit_purchase"]}
              renderNoAccess={<PermissionRequired />}
            >
              <EditDraftPurchase />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/debit-note/create"}
          element={
            <AccessControl
              allowedPermissions={["can_create_debit_note"]}
              renderNoAccess={<PermissionRequired />}
            >
              <CreateDebitNote />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/customer/create"}
          element={<CreateCustomer />}
        />
        <Route
          path={"/accounting/supplier/create"}
          element={<CreateSupplier />}
        />

        <Route
          path={"/accounting/inventory"}
          element={
            <AccessControl
              allowedPermissions={["can_view_inventory"]}
              renderNoAccess={<PermissionRequired />}
            >
              <InventoryInfo />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/service"}
          element={
            <AccessControl
              allowedPermissions={["can_view_service_info"]}
              renderNoAccess={<PermissionRequired />}
            >
              <ServiceInfo />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/purchase-register"}
          element={
            <AccessControl
              allowedPermissions={["can_view_purchase_register"]}
              renderNoAccess={<PermissionRequired />}
            >
              <PurchaseRegister />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/sales-register"}
          element={
            <AccessControl
              allowedPermissions={["can_view_sales_register"]}
              renderNoAccess={<PermissionRequired />}
            >
              <SalesRegister />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/sales-return-register"}
          element={
            <AccessControl
              allowedPermissions={["can_view_sales_return_register"]}
              renderNoAccess={<PermissionRequired />}
            >
              <SalesReturnRegister />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/purchase-return-register"}
          element={
            <AccessControl
              allowedPermissions={["can_view_purchase_return_register"]}
              renderNoAccess={<PermissionRequired />}
            >
              <PurchaseReturnRegister />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/product-group"}
          element={
            <AccessControl
              allowedPermissions={["can_view_product_group"]}
              renderNoAccess={<PermissionRequired />}
            >
              <ProductGroupList />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/stock-trial-group"}
          element={
            <AccessControl
              allowedPermissions={["can_view_grouped_stock_trial"]}
              renderNoAccess={<PermissionRequired />}
            >
              <StockTrial />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/stock-valuation-group"}
          element={
            <AccessControl
              allowedPermissions={["can_view_grouped_stock_valuation"]}
              renderNoAccess={<PermissionRequired />}
            >
              <StockValuation />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/stock-valuation-normal"}
          element={
            <AccessControl
              allowedPermissions={["can_view_normal_stock_valuation"]}
              renderNoAccess={<PermissionRequired />}
            >
              <StockValuationNormal />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/stock-valuation-detail"}
          element={
            <AccessControl
              allowedPermissions={["can_view_detail_stock_valuation"]}
              renderNoAccess={<PermissionRequired />}
            >
              <StockValuationDetail />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/stock-movement-group"}
          element={
            <AccessControl
              allowedPermissions={["can_view_grouped_stock_movement"]}
              renderNoAccess={<PermissionRequired />}
            >
              <StockMovement />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/stock-ledger-normal"}
          element={
            <AccessControl
              allowedPermissions={["can_view_normal_stock_ledger"]}
              renderNoAccess={<PermissionRequired />}
            >
              <StockLedgerNormal />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/stock-ledger-detail"}
          element={
            <AccessControl
              allowedPermissions={["can_view_detail_stock_ledger"]}
              renderNoAccess={<PermissionRequired />}
            >
              <StockLedgerDetail />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/stock-movement-normal"}
          element={
            <AccessControl
              allowedPermissions={["can_view_normal_stock_movement"]}
              renderNoAccess={<PermissionRequired />}
            >
              <StockMovementNormal />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/stock-trial-normal"}
          element={
            <AccessControl
              allowedPermissions={["can_view_normal_stock_trial"]}
              renderNoAccess={<PermissionRequired />}
            >
              <StockTrialNormal />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/inventory/create"}
          element={
            <AccessControl
              allowedPermissions={["can_add_product"]}
              renderNoAccess={<PermissionRequired />}
            >
              <AddProduct />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/service/create"}
          element={
            <AccessControl
              allowedPermissions={["can_view_service_info"]}
              renderNoAccess={<PermissionRequired />}
            >
              <AddService />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/service-report"}
          element={<ServiceReport />}
        />
        <Route
          path={"/accounting/inventory/edit/:id"}
          element={
            <AccessControl
              allowedPermissions={["can_edit_inventory"]}
              renderNoAccess={<PermissionRequired />}
            >
              <EditProduct />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/service/edit/:id"}
          element={
            <AccessControl
              allowedPermissions={["can_edit_service_info"]}
              renderNoAccess={<PermissionRequired />}
            >
              <EditServiceInfo />
            </AccessControl>
          }
        />
        <Route
          path={"/accounting/customer/edit/:id"}
          element={<EditCustomer />}
        />
        <Route
          path={"/accounting/supplier/edit/:id"}
          element={<EditSupplierUser />}
        />
        <Route
          path={"/accounting/configuration"}
          element={
            <AccessControl
              allowedPermissions={["can_view_configuration"]}
              renderNoAccess={<PermissionRequired />}
            >
              <Configuration />
            </AccessControl>
          }
        />
      </Route>
    </Routes>
  );
};

export default Router;

